export const generateColumns = (data: any) => {
  const columns: any = [];

  data.forEach((item: any) => {
    if (item.subNav) {
      item.subNav.forEach((subItem: any) => {
        columns.push({
          headerName: subItem.title,
          field: subItem.path,
          width: 150,
          cellRenderer: 'agCheckboxCellRenderer',
          cellEditor: 'agCheckboxCellEditor',
          valueSetter: (params: any) => {
            params.data[params.colDef.field] = params.newValue;
            return true;}
        });
      });
    } else {
      columns.push({
        headerName: item.title,
        field: item.path,
        width: 150,
        cellRenderer: 'agCheckboxCellRenderer',
        cellEditor: 'agCheckboxCellEditor',
        valueSetter: (params: any) => {
          params.data[params.colDef.field] = params.newValue;
          return true;}
      });
    }
  });

  return columns;
};
